
export let APINotSupportedForRDLError: string = "This API is currently not supported for RDL reports";




// WEBPACK FOOTER //
// ./src/errors.ts